import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { LocaleService } from '../services/locale.service';

@Injectable({ providedIn: 'root' })
export class IsraeliOnlyGuard implements CanActivate {
  constructor(private locale: LocaleService, private router: Router) {}
  canActivate(): boolean | UrlTree {
    return this.locale.israeliMarket ? true : this.router.createUrlTree(['/']);
  }
}
